import React from "react";
import { Route, Routes, Navigate, BrowserRouter, useLocation } from "react-router-dom";
import { auth } from "./firebase.js";
import {
  Account,
  App,
  Login,
  Venue,
  Action,
  VerifyEmail,
  SignIn,
  Membership,
  Threads,
  Signup,
  SignupService,
  Requests,
  Stats,
  ForgotPassword,
  ResetPassword,
  NotFound,
  Unsubscribe,
  ServiceEdit,
  AdminServices,
  UploadPhotos,
} from "./pages/index.js";

const publicRoutes = ["/login", "/action", "/verify-email", "/forgot-password", "/reset-password", "/signup", "/signup-service", "/sign-in", "/afmelden"];

function Private(props) {
  const location = useLocation();
  if (!auth.currentUser) {
    return <Navigate replace to="/login" state={{ from: location.pathname }} />;
  }
  if (auth.currentUser.isAnonymous) {
    return <Navigate replace to="/signup" />;
  }
  return props.children;
}

function Router() {
  return (
    <BrowserRouter>
      <App publicRoutes={publicRoutes}>
        <Routes>
          <Route path="/login" element={<Login name="Login" />} />
          <Route path="/action" element={<Action name="Action" />} />
          <Route path="/verify-email" element={<VerifyEmail name="VerifyEmail" />} />
          <Route path="/sign-in" element={<SignIn name="SignIn" />} />
          <Route path="/forgot-password" element={<ForgotPassword name="ForgotPassword" />} />
          <Route path="/reset-password" element={<ResetPassword name="ResetPassword" />} />
          <Route path="/signup" element={<Signup name="Signup" />} />
          <Route path="/signup-service" element={<SignupService name="SignupService" />} />
          <Route path="/afmelden" element={<Unsubscribe name="Unsubscribe" />} />
          <Route path="/upload/:token" element={<UploadPhotos name="UploadPhotos" />} />

          <Route
            path="/account"
            element={
              <Private>
                <Account name="Account" />
              </Private>
            }
          />
          <Route
            path="/membership"
            element={
              <Private>
                <Membership name="Membership" />
              </Private>
            }
          />
          <Route
            path="/abonnement-service"
            element={
              <Private>
                <Navigate replace to="/mijn-dienst" />
              </Private>
            }
          />
          <Route
            path="/mijn-dienst"
            element={
              <Private>
                <ServiceEdit name="ServiceEdit" />
              </Private>
            }
          />
          <Route
            path="/diensten-goedkeuren"
            element={
              <Private>
                <AdminServices name="AdminServices" />
              </Private>
            }
          />
          <Route
            path="/threads"
            element={
              <Private>
                <Threads name="Threads" />
              </Private>
            }
          >
            <Route
              path=":venueId"
              element={
                <Private>
                  <Threads name="Threads" />
                </Private>
              }
            />
          </Route>
          <Route
            path="/stats"
            element={
              <Private>
                <Stats name="Stats" />
              </Private>
            }
          >
            <Route
              path=":venueId"
              element={
                <Private>
                  <Stats name="Stats" />
                </Private>
              }
            />
          </Route>
          <Route
            path="/requests"
            element={
              <Private>
                <Requests name="Requests" />
              </Private>
            }
          >
            <Route
              path=":venueId"
              element={
                <Private>
                  <Requests name="Requests" />
                </Private>
              }
            />
          </Route>
          <Route path="/">
            <Route
              index
              element={
                <Private>
                  <Venue name="Venue" />
                </Private>
              }
            />
            <Route path="venues">
              <Route
                index
                element={
                  <Private>
                    <Venue name="Venue" />
                  </Private>
                }
              />
              <Route
                path=":venueId"
                element={
                  <Private>
                    <Venue name="Venue" />
                  </Private>
                }
              />
            </Route>
          </Route>
          <Route
            path="*"
            element={
              <Private>
                <NotFound name="NotFound" />
              </Private>
            }
            exact
          />
        </Routes>
      </App>
    </BrowserRouter>
  );
}

export default Router;
